// VideoWindowPopoutState is exported for the reducer to set OPEN and CLOSE states.
export const VideoPopoutState = {
  CLOSE: 1,
  OPEN: 2
};
